var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-2"},[_c('b-col',[(_vm.title)?_c('h3',[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }